import { FC, useCallback } from "react";
import { useForm } from "react-hook-form";
import { Button, Typography } from "theme";

import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Grid2 } from "@mui/material";

import { InvertButton } from "../../../theme/components/Button/Button.tsx";
import { useBooking } from "../../../utils/context/Booking/BookingContext.tsx";

import EquipmentGroup from "./components/EquipmentGroup.tsx";
import { EquipmentFormScheme, equipmentScheme } from "./validation.ts";

type EquipmentFormProps = {
  setStep: (step: number) => void;
}

const EquipmentForm: FC<EquipmentFormProps> = ({ setStep }) => {
  const { setEquipment, equipment } = useBooking();

  const {
    handleSubmit,
    control,
  } = useForm<EquipmentFormScheme>({
    reValidateMode: "onSubmit",
    resolver: zodResolver(equipmentScheme),
    defaultValues: equipment || {
      equipment: [],
    },
  });

  const onSubmit = useCallback((data: EquipmentFormScheme) => {
    setEquipment(data);
    setStep(3);
  }, [setEquipment, setStep]);

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate my={3.5}>
      <Typography mb={4.5} variant="h1" textTransform="uppercase" weight="semiBold">
        Обладнання
      </Typography>

      <Box mt={1.5} mb={8.75}>
        <EquipmentGroup name="equipment" control={control} />
      </Box>

      <Grid2 container justifyContent="space-between">
        <Button type="button" look="normal" onClick={() => setStep(1)}>
          Назад
        </Button>

        <InvertButton type="submit">
          Продовжити
        </InvertButton>
      </Grid2>
    </Box>
  );
};

export default EquipmentForm;
